//#region Action Interface

interface DisplayCallToActionButtonsAction
{
    type: 'DISPLAY_CALL_TO_ACTION_BUTTONS';
    entryId: string;
}

interface DisableCallToActionButtonsAction
{
    type: 'DISABLE_CALL_TO_ACTION_BUTTONS';
    entryId: string;
}

//#endregion


//#region ActionTypes

export type CallToActionButtonActionType = DisplayCallToActionButtonsAction | DisableCallToActionButtonsAction;

//#endregion



//#region Action Constructors

export function displayCallToActionButtons(entryId: string): CallToActionButtonActionType
{
    return {
        type: 'DISPLAY_CALL_TO_ACTION_BUTTONS',
        entryId,
    };
}

export function disableCallToActionButtons(entryId: string): CallToActionButtonActionType
{
    return {
        type: 'DISABLE_CALL_TO_ACTION_BUTTONS',
        entryId,
    };
}

//#endregion



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-call-to-action/src/actions/Actions.ts